import { useState, useEffect } from "react";
import { api, dataProvider } from "data";
import { apiMethods } from "data/api.constants";
import { STATISTICS_TYPE_MAP } from "../constants";
import { DEFAULT_PER_PAGE } from "constants/numbers";

export const useFetchAudience = (
  open,
  campaignUid,
  field,
  isWhatsApp = false,
  dripSource,
  page = 1
) => {
  const [loading, setLoading] = useState(false);
  const [audienceList, setAudienceList] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (!open || !campaignUid) return;

    const fetchAudience = async () => {
      setLoading(true);
      try {
        const statsType = STATISTICS_TYPE_MAP[field];
        const apiEndpoint = isWhatsApp
          ? api.get_whatsapp_campaign_details
          : api.get_email_campaign_details;

        const response = await dataProvider.custom_request(
          apiEndpoint,
          apiMethods.GET,
          {
            campaign_uuid: campaignUid,
            statistics_type: statsType,
            page: page,
            ...(dripSource && { drip_source: dripSource }),
          }
        );
        if (response?.data) {
          const statsList =
            response.data.email_statistics ||
            response.data.whatsapp_statistics ||
            (Array.isArray(response.data) ? response.data : []);

          const data = statsList.map((item) => ({
            ...item,
            name: item.name || item.recipient_name,
            phone_number: item.phone_number || item.phone,
          }));
          setAudienceList(data);

          const totalP = response.data.total_pages || 1;
          setTotalPages(totalP);

          const countKey = `${statsType}_count`;
          const calculatedTotal =
            response.data[countKey] ??
            response.data.total_count ??
            response.data.total ??
            response.data.count ??
            response.data.attempted_count ??
            response.data.sent_count ??
            response.data.delivered_count ??
            response.data.opened_count ??
            response.data.replied_count ??
            response.data.failed_count ??
            (totalP > 1 ? totalP * DEFAULT_PER_PAGE : data.length);

          setTotalCount(calculatedTotal);
        } else {
          setAudienceList([]);
          setTotalPages(1);
          setTotalCount(0);
        }
      } catch (error) {
        console.error("Error fetching campaign details:", error);
        setAudienceList([]);
        setTotalPages(1);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchAudience();
  }, [open, campaignUid, field, isWhatsApp, dripSource, page]);

  return { loading, audienceList, totalPages, totalCount };
};

export const filterAudienceList = (audienceList, filterValues) => {
  return audienceList.filter((item) => {
    return Object.entries(filterValues).every(([key, val]) => {
      if (val === undefined || val === null || val === "") return true;

      let fieldName = key;
      let isContains = false;

      if (key.endsWith("__icontains")) {
        fieldName = key.replace("__icontains", "");
        isContains = true;
      }

      let itemVal = item[fieldName];
      if (fieldName === "phone_number" && itemVal === undefined) {
        itemVal = item["phone"];
      }

      if (itemVal === undefined || itemVal === null) return false;

      const itemStr = String(itemVal).toLowerCase();
      const searchStr = String(val).toLowerCase();

      if (isContains) {
        return itemStr.includes(searchStr);
      } else {
        return itemStr === searchStr;
      }
    });
  });
};

export const tableChipsFormatter = (filter, value) => {
  switch (filter) {
    case "name__icontains":
      return `Recipient Name: ${value}`;
    case "phone_number__icontains":
      return `Phone number: ${value}`;
    case "email__icontains":
      return `Email ID: ${value}`;
    default:
      return undefined;
  }
};
